import Alert from '@mui/material/Alert'
import Box from '@mui/material/Box'
import CircularProgress from '@mui/material/CircularProgress'
import Paper from '@mui/material/Paper'
import Typography from '@mui/material/Typography'
import { ApiError } from '../../lib/api'

export function LoadingBlock({ label = 'טוען…' }: { label?: string }) {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, py: 6, justifyContent: 'center' }}>
      <CircularProgress size={22} />
      <Typography color="text.secondary">{label}</Typography>
    </Box>
  )
}

export function ErrorAlert({ error, onRetry }: { error: unknown; onRetry?: () => void }) {
  const message =
    error instanceof ApiError
      ? error.message
      : error instanceof Error
        ? error.message
        : 'שגיאה בלתי צפויה'

  return (
    <Alert
      severity="error"
      sx={{ my: 2 }}
      action={
        onRetry ? (
          <Typography
            component="button"
            onClick={onRetry}
            sx={{
              background: 'none',
              border: 0,
              cursor: 'pointer',
              color: 'inherit',
              textDecoration: 'underline',
              font: 'inherit',
            }}
          >
            נסה שוב
          </Typography>
        ) : undefined
      }
    >
      {message}
    </Alert>
  )
}

export function EmptyState({ title, hint }: { title: string; hint?: string }) {
  return (
    <Paper variant="outlined" sx={{ p: 4, textAlign: 'center', bgcolor: 'transparent' }}>
      <Typography variant="subtitle1" color="text.secondary">
        {title}
      </Typography>
      {hint ? (
        <Typography variant="body2" color="text.disabled" sx={{ mt: 0.5 }}>
          {hint}
        </Typography>
      ) : null}
    </Paper>
  )
}
